import React, {FC, useState} from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {AlertDialog} from '../../../common/dialogs/alertDialog';
import {SideFrameDialogMessage} from './sideFrameDialogMessage';
import {SideFrameDialogDefinition} from './sideFrameDialogsHooks';

/*
 * Props.
 */

interface SideFrameAlertProps {
  alertData: AlertDefinition;
  onRequestClose: Handler;
  onOkClick: Handler;
}

/*
 * Component.
 */

const SideFrameAlert: FC<SideFrameAlertProps> = ({alertData, onOkClick, onRequestClose}) => {
  const {title, message, okTitle} = alertData;

  return (
    <AlertDialog onRequestClose={onRequestClose} onOkClick={onOkClick} okTitle={okTitle} title={title}>
      <SideFrameDialogMessage>{message}</SideFrameDialogMessage>
    </AlertDialog>
  );
};

/*
 * Hook.
 */

interface AlertDefinition extends SideFrameDialogDefinition {
  title: string;
  message: string;
  okTitle: string | null;
}

export function useSideFrameAlert() {
  const [alertData, setAlertData] = useState<AlertDefinition | null>(null);
  if (!alertData) {
    return {
      setAlertData,
      alert: null,
    };
  }

  const onRequestClose = () => {
    setAlertData(null);
  };

  const onOkClick = () => {
    if (!alertData) {
      return;
    }

    alertData.onDone(true);
    onRequestClose();
  };

  return {
    setAlertData,
    alert: <SideFrameAlert alertData={alertData} onRequestClose={onRequestClose} onOkClick={onOkClick} />,
  };
}
